import React, { useState, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@/services/hooks";
// ACtions
import { saveSettingsOptional } from "@/services/templateServices/templateAction";
// Get All products
// Get All categories
// Get All ads
// Get All posts linked to the current blog
// Media selector
import ModelMediaContainer from "../../Media/ModelMediaContainer";
import VariableField from "../../variableFields/VariableField";
import { useVariableOptions } from "../../variableFields/useVariableOptions";

// reactstrap components
import {
  Col,
  Label,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
  Row,
  Form,
} from "reactstrap";
// nodejs library that concatenates classes




function HandleOptional() {
    const dispatch = useAppDispatch();

  const settingsOptional = useAppSelector(
    (state) => state.templates.settings_optional
  );

  // All settings variables of this bucket (local copy of the redux slice)
  const [Variables, setVariables] = useState<any[]>([]); // any: copies templates.settings_optional, typed any[] there (templateSlice.ts:27)
  // shared option lists for the entity building blocks (SCRUM-554)
  const variableOptions = useVariableOptions();

  useEffect(() => {
    // match local state to redux state to be able to handle it
    setVariables(settingsOptional);
  }, [settingsOptional]);























  // VariableField building blocks (SCRUM-551) report (name, value);
  // persist exactly like the legacy handlers: update local state and
  // save the full variables list to redux.
  const applyFieldValue = (name, value) => {
    const updated = Variables.map((settingVar) =>
      settingVar.variable === name ? { ...settingVar, value } : settingVar
    );
    setVariables(updated);
    dispatch(saveSettingsOptional(updated));
  };

      if (Variables.length > 0) {
        return (
          <div>
            {Variables.map((settingVar) => {
    
              // Case String => simple input
              if (settingVar.type === "String") {
                // Case logo/option => Cloudinary image picker instead of text input
                if (settingVar.variable === 'logo' || settingVar.variable === 'option') {
                  const onImageSelect = (selectedImage) => {
                    if (selectedImage && selectedImage.secure_url) {
                      applyFieldValue(settingVar.variable, selectedImage.secure_url);
                    }
                  };

                  return (
                    <div key={settingVar.variable} className="mb-3">
                      <Row>
                        <Label className="form-control-label" md="3">
                          {settingVar.variable}
                        </Label>
                        <Col md="3">
                          <ModelMediaContainer selectedImg={onImageSelect} />
                        </Col>
                        <Col md="6">
                          {settingVar.value && (
                            <img
                              src={settingVar.value}
                              alt={settingVar.variable}
                              style={{ maxWidth: '100%', maxHeight: 80, objectFit: 'cover', borderRadius: 6 }}
                            />
                          )}
                        </Col>
                      </Row>
                    </div>
                  );
                }
                  }
    

              // Every registry type renders through the VariableField dispatcher
              // (SCRUM-551/552/553); unknown types render nothing, exactly like the
              // legacy fall-through. Entity types get their options injected here.
              return (
                <VariableField
                  key={settingVar.variable}
                  settingVar={settingVar}
                  options={variableOptions[settingVar.type]}
                  onChange={applyFieldValue}
                />
              );
            })}
          </div>
        );
      } else if (Variables.length === 0) {
        return <div>No Optional settings variables available...</div>;
      } else {
        return <div>Error try again...</div>;
      }
    }

export default HandleOptional
